var _path, _path2, _path3, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440.39 713.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.72,556.23c-14.31,0-26.02-11.39-26.43-25.69l-2-71.17c-1.03-36.71-14-72.23-37.57-100.39-24.26-29-51.88-75.68-51.44-137.6C15.51,153.25,70.67,19.56,222.04,19.56s210.37,133.69,202.59,201.83c.44,61.92-27.18,108.6-51.44,137.6-23.56,28.16-36.53,63.69-37.57,100.39l-2,71.17c-.4,14.3-12.11,25.69-26.43,25.69h-166.47Z",
    opacity: 1,
    fill: "#eee600"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0s",
    dur: "2s",
    from: 1,
    to: 0,
    repeatCount: "indefinite"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.02,556.23c-14.31,0-26.02-11.39-26.43-25.69l-2-71.17c-1.03-36.71-14-72.23-37.57-100.39-24.26-29-51.88-75.68-51.44-137.6C12.8,153.25,67.97,19.56,219.34,19.56s210.37,133.69,202.59,201.83c.44,61.92-27.18,108.6-51.44,137.6-23.56,28.16-36.53,63.69-37.57,100.39l-2,71.17c-.4,14.3-12.11,25.69-26.43,25.69h-166.47Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M249.15,556.23s-7.06-235.99,33.64-298.41c8.18-12.54,24.24-18.07,37.85-11.83,24.85,11.38,24.55,51.41-16.45,49.55-30.59-.57-129.92-1.91-160.51-1.34-41,1.86-41.3-38.16-16.45-49.55,13.61-6.24,29.68-.71,37.85,11.83,40.7,62.42,33.64,298.41,33.64,298.41",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 123.83,
    y1: 622.75,
    x2: 318.66,
    y2: 622.75,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 173.14,
    y1: 689.26,
    x2: 270.56,
    y2: 689.26,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.16eeb55a57c2e6018122f62dbe65ed3a.svg";
export { ForwardRef as ReactComponent };